import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useAppTitle } from '@lwtears/lwt-common-frontend/lib/@common';
import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import StudentPinTiles from './StudentPinTiles';
import StudentPinPassword from './StudentPinPassword';

const t = (key) => translate('common', key);
const tApp = (app, key) => translate(app, key);

const StudentPin = (props) => {
  const { login } = props.users.find((user) => user.id === props.selectedUserId);
  const app = useSelector((state) => state.login.app);

  useAppTitle(`${t('EnterYourSecretCode')} - ${t('StudentLogin')} - ${tApp(app, 'appTitle')}`);

  const mappedComponent =
    login.type === 'LETTER_CARDS' ? (
      <StudentPinTiles {...props} />
    ) : (
      <StudentPinPassword {...props} />
    );

  return mappedComponent;
};

StudentPin.propTypes = {
  error: PropTypes.object,
  goToStep: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  loginUser: PropTypes.func.isRequired,
  selectedClassId: PropTypes.number,
  selectedUserId: PropTypes.number,
  clearLoginError: PropTypes.func.isRequired,
  users: PropTypes.array
};

export default StudentPin;
